import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaSelectModel, SmMetaInputModel } from "common/models/utility-models/meta-model";

export class GroupDetailsMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.groups, '', 3, '', false, '', '', 'row align-items-start justify-content-start');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const batch_id = new SmMetaSelectModel(
            'batch_id',
            'batch_id',
            'ng-select',
            true,
            'col-12 col-md-4',
            1,
            1,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'batch_number',
            'id',
            false,
            false,
            false,
            false,
            false,
            false,
            { evalKey: '', evalParam: [] },
            null,
            false,
            [],
            false

        );
        const group_name = new SmMetaInputModel(
            'group_name',
            'group_name',
            'input',
            true,
            'col-12 col-md-4',
            1,
            2,
            'Group Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
     


        // const buttons = {
        //     submit: new SmBtnMetaModel('Submit', '', true, false, false, true),
        //     isFormControl: false,
        // };


        return {
            formInfo,
            batch_id,
            group_name,
            isBatchChanged: false
        }
    }
}